module.exports = __webpack_public_path__ + "static/media/preloader-Big-HIPPO-withText-Flood.7902e974.gif";